import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { CodeBlock } from '../../components/CodeBlock';
import { InfoBox } from '../../components/InfoBox';
export function SdkClickToPayPage() {
  return <DocPageLayout title="Click to Pay SDK" description="Enable Click to Pay (formerly SRC) for a streamlined checkout experience." breadcrumbs={[{
    label: 'API Reference',
    id: 'api-overview'
  }, {
    label: 'SDKs'
  }, {
    label: 'Click to Pay'
  }]} data-id="element-817">
      <p className="text-gray-700 mb-8" data-id="element-818">
        Click to Pay allows returning customers to pay with saved cards across
        participating merchants without re-entering card details. It is powered
        by the EMVCo Secure Remote Commerce (SRC) standard.
      </p>
      <h2 className="text-2xl font-bold text-gray-900 mt-6 mb-4" data-id="element-819">
        Integration
      </h2>
      <CodeBlock language="HTML" title="Script Include" code={`<script src="https://test-gateway.mastercard.com/static/clickToPay/v1/clickToPay.js"></script>`} data-id="element-820" />
      <CodeBlock language="JavaScript" title="Configuration" code={`ClickToPay.configure({
  merchantId: "YOUR_MERCHANT_ID",
  session: { id: "SESSION_ID" },
  cardBrands: ["mastercard", "visa"],
  locale: "en_US",
  container: "#click-to-pay-container",
  callbacks: {
    onReady: function() { console.log("Click to Pay ready"); },
    onPaymentComplete: function(result) { console.log("Payment:", result); },
    onError: function(error) { console.error("Error:", error); }
  }
});`} data-id="element-821" />
      <InfoBox type="info" title="Supported Brands" data-id="element-822">
        Click to Pay currently supports Mastercard and Visa. Additional card
        brands may be available depending on your region.
      </InfoBox>
    </DocPageLayout>;
}